export const ACTUALIZAR_LIST_PROCEDIMIENTO = "ACTUALIZAR_LIST_PROCEDIMIENTO";
export const MODIFICAR_PROCEDIMIENTO = "MODIFICAR_PROCEDIMIENTO";
export const AGREGAR_PROCEDIMIENTO = "AGREGAR_PROCEDIMIENTO";  
export const ELIMINAR_PROCEDIMIENTO = "ELIMINAR_PROCEDIMIENTO";